import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';
import * as _ from 'underscore';
import { SessionService } from '../shared';

export class NavListItem {
   title:string;
   icon?:string;
   stateName:string;
   otherStates?:string[];
   children?:NavListItem[];
   expanded = false;

   constructor(nav, state?:uir.StateDeclaration) {
      this.stateName = nav.stateName ? nav.stateName : state.name;
      this.otherStates = nav.otherStates;

      this.title = nav.title;
      this.icon = nav.icon;

      if (nav.children) {
         this.children = _.map(nav.children, c => new NavListItem(c));
      }
   }
}

export class NavListService {
   showNav = false;

   static $inject = ['$stateRegistry', 'session'];

   constructor(
      private $stateRegistry:uir.StateRegistry,
      private session:SessionService
   ) { }

   get navItems() {
      let navItems:NavListItem[] = [];

      for (let state of this.$stateRegistry.get()) {
         // child states inherit parent data, skip states with parent nav
         let parent = this.getParentState(state);
         if (parent && parent.data && parent.data.nav) {
            continue;
         }

         if (state.data && state.data.nav) {
            let item:NavListItem = new NavListItem(state.data.nav, state);

            if (this.session.isAuthorized(this.getRoles(state))) {
               if (item.children) {
                  item.children = _.filter(item.children, (child) => {
                     let childState = this.$stateRegistry.get(child.stateName);
                     return this.session.isAuthorized(this.getRoles(childState));
                  });
               }

               navItems.push(item);
            }
         }
      }

      return navItems;
   }

   private getParentState(state:uir.StateDeclaration) {
      if (state.parent) {
         return this.$stateRegistry.get(state.parent);
      }

      if (state.name.indexOf('.') != -1) {
         return this.$stateRegistry.get(state.name.split('.')[0]);
      }

      return null;
   }

   private getRoles(state:uir.StateDeclaration) {
      while (true) { // danger Will Robinson!
         if (state.data && state.data.roles) {
            return state.data.roles;
         } else {
            state = this.getParentState(state);
         }
      }
   }
}

ng.module('e360').service('navList', NavListService);
